// ─────────────────────────────────────────────────────────────────────────────
// Aviso vermelho da sobrescrita de fotos.
//
// Texto obrigatorio do plano do Cut App, secao 11.3
// (docs/plano-integracao-cutapp-produtos-precos.md). Nao editar sem revisar o plano.
//
// O comportamento destrutivo NAO e exclusivo do Cut App: o sync de Shopee/Mercado
// Livre tambem substitui `imageUrls` inteiro (marketingStudioService, upserts dos
// syncs de produto), descartando as fotos de Produzir Fotos / Produzir Videos e
// trocando a foto de referencia. Por isso o aviso e compartilhado e a origem e
// parametrizada.
// ─────────────────────────────────────────────────────────────────────────────

export const PHOTO_WARNING_TITLE = 'Ao sobrescrever, todas as fotos de todos os produtos com o mesmo SKU serao removidas';

/** `sourceLabel` = 'do Cut App' (padrao) ou 'do anuncio'. */
export function photoWarningBody(sourceLabel: string = 'do Cut App') {
  return (
    `Ao sobrescrever, todas as fotos de todos os produtos com o mesmo SKU serao removidas e substituidas pelas ${sourceLabel}. `
    + 'Isso inclui as fotos geradas nos pipelines de Produzir Fotos / Produzir Videos e troca a foto de referencia do produto.'
  );
}

/** Mantido para compatibilidade com o texto literal do Cut App. */
export const PHOTO_WARNING_BODY = photoWarningBody('do Cut App');

export function PhotoOverwriteWarning({ compact, sourceLabel }: { compact?: boolean; sourceLabel?: string }) {
  return (
    <div className={`rounded-lg border-2 border-red-500 bg-red-50 ${compact ? 'p-3' : 'p-4'}`}>
      <p className="flex items-start gap-2 text-sm font-bold uppercase tracking-wide text-red-700">
        <span aria-hidden>🚨</span>
        <span>{PHOTO_WARNING_TITLE}</span>
      </p>
      <p className="mt-2 text-sm font-semibold leading-6 text-red-700">{photoWarningBody(sourceLabel)}</p>
      <ul className="mt-2 list-disc space-y-1 pl-5 text-xs font-medium text-red-700">
        <li>Todas as fotos de <strong>todos os produtos com o mesmo SKU</strong> sao removidas, nao apenas de um produto.</li>
        <li>As fotos geradas em <strong>Produzir Fotos</strong> e <strong>Produzir Videos</strong> sao descartadas.</li>
        <li>A <strong>foto de referencia</strong> do produto muda - as proximas geracoes usam a nova primeira foto.</li>
      </ul>
    </div>
  );
}
